export const GET_PDFS = 'GET_PDFS';
export const SET_PDFS = 'SET_PDFS';
